export default __webpack_public_path__ + "static/media/menu.1f2699ef.svg";